"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports["default"] = void 0;
var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));
var _inheritsLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/inheritsLoose"));
var _react = _interopRequireDefault(require("react"));
var _commonHorizontalList = _interopRequireDefault(require("../styles/common-horizontal-list.css"));
var SelectMenu = /*#__PURE__*/function (_React$Component) {
  (0, _inheritsLoose2["default"])(SelectMenu, _React$Component);
  // All components need a resourceType in order for AEM to be aware of its existance
  SelectMenu.resourceType = function resourceType() {
    return 'SelectMenu_1_0_0';
  };
  function SelectMenu(props) {
    var _this;
    _this = _React$Component.call(this, props) || this;
    _this.handleChange = _this.handleChange.bind((0, _assertThisInitialized2["default"])(_this));
    return _this;
  }
  var _proto = SelectMenu.prototype;
  _proto.handleChange = function handleChange(_ref) {
    var value = _ref.target.value;
    var valueAsInteger = parseInt(value, 10);
    var onChange = this.props.onChange;
    onChange(valueAsInteger);
  };
  _proto.render = function render() {
    var _this$props = this.props,
      options = _this$props.options,
      selectName = _this$props.selectName,
      theme = _this$props.theme,
      value = _this$props.value;
    var name = selectName === undefined ? "tab-select-" + Math.random() : selectName;
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: _commonHorizontalList["default"].selectMenuWrapper
    }, /*#__PURE__*/_react["default"].createElement("select", {
      onChange: this.handleChange,
      value: value,
      name: name,
      "aria-label": name,
      className: theme.customSelect
    }, options.map(function (option, index) {
      return /*#__PURE__*/_react["default"].createElement("option", {
        key: name + "_" + option,
        value: index
      }, option);
    })));
  };
  return SelectMenu;
}(_react["default"].Component);
exports["default"] = SelectMenu;
SelectMenu.displayName = 'SelectMenu';
SelectMenu.defaultProps = {
  options: [],
  onChange: function onChange() {
    return null;
  }
};